import axios from "axios";

// set defaults for API calls
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
});

const makeRequest = async (method, url, data, headers) => {
  // Getting the token directly from local storage to avoid having to 
  // instantiate the "AuthService". I'm not sure this is the "ideal" way to go...
  const oktaTokens = window.localStorage.getItem('okta-token-storage')
    ? JSON.parse(window.localStorage.getItem('okta-token-storage'))
    : null;

  const accessToken = oktaTokens && Object.keys(oktaTokens).length > 0 ? oktaTokens?.accessToken?.accessToken : null;

  // if you had multiple browser tabs open and logged out of one, 
  // the tokens would be gone and navigating could throw errors
  // we should just redirect back to the login since we can't call the API without tokens
  if (!accessToken) { 
    console.error('No tokens found. Redirecting to login.');
    document.location = "/";
    throw new Error('No access token found. Redirecting to login.');
  }

  headers = {
    "Content-type": "application/json",
    Authorization: `Bearer ${accessToken}`,
    ...headers,
  };

  try {
    const response = await instance.request({
      url,
      method,
      data,
      headers
    });

    return response;
  } catch(err) {
    if (err.response){
      console.error(err.response);
      throw err;
    } else {
      throw new Error(err);
    }
  }
};

const request = async (method, url, data, headers) => {
  return (await makeRequest(method, url, data, headers)).data;
}

export const Api = {
  get: (endpoint, data, headers) => request('get', endpoint, data, headers),
  post: (endpoint, data, headers) => request('post', endpoint, data, headers),
  put: (endpoint, data, headers) => request('put', endpoint, data, headers),
};